const releaseOfPersonalInformationAgreement = {
    "children": [
        {
            "children": [{"text": "一、蒐集之特定目的"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "TAF基於下列特定目的蒐集、處理、利用本人之個人資料："}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "(一) TAF訓練課程講師管理。"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "(二) 參訓單位申請政府補助經費(TTQS、職訓局計畫…等)使用。"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "(三) 其他經營合於TAF營業登記項目或捐助章程所定之業務。"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": ""}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "二、蒐集及處理之個人資料類別"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "(一) 辨識個人者：如姓名、性別、出生年月日、身分證字號、戶籍地址、聯絡方式(Email、電話)等。"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "(二) 個人描述：如服務單位名稱(含職稱)、部門、工作地址、相關學經歷、相關訓練紀錄等。"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "(三) 付款作業：提供其個人之本會匯款銀行及帳號。"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": ""}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "三、利用之期間、地區、對象及方式"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "本人同意TAF於特定目的存續期間、相關法令或契約約定就個人資料之保存期間、TAF因執行業務必須之保存期間，在本國及外國，與TAF有業務往來之國內外機構、與TAF往來之國內外合作單位，得以自動化機器或其他非自動化方式利用本人個人資料。"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": ""}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "四、本人知悉就本人提供之個人資料得以自己之費用向TAF行使下列權利："}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "(一) 查詢或請求閱覽。"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "(二) 請求製給複製本。"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "(三) 請求補充或更正。"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "(四) 請求停止蒐集、處理或利用。"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "(五) 請求刪除。"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": ""}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "五、本人得自由選擇是否提供本人個人資料，但本人提供之個人資料，如有內容不完整，或經TAF發現不足以確認本人身分真實性，或個人資料不實等情形，可能影響TAF對資料管理之正確性，或無法繼續擔任本項職務。"}],
            "type": "paragraph"
        },
        {
            "children": [{"text": ""}],
            "type": "paragraph"
        },
        {
            "children": [{"text": "本人已完全知悉前揭告知事項，並同意TAF基於本同意書，蒐集處理利用本人個人資料。"}],
            "type": "paragraph"
        }
    ],
    "type": "rtx"
}

export default releaseOfPersonalInformationAgreement;